// Travel Insurance Add More Covers Flow Constants
export const ADD_MORE_COVERS_FLOW_TRAVEL = "ADD_MORE_COVERS_FLOW_TRAVEL";
export const ADD_MORE_COVERS_TRAVEL_ENHANCE_YOUR_COVERAGE = "ADD_MORE_COVERS_TRAVEL_ENHANCE_YOUR_COVERAGE";
export const ADD_MORE_COVERS_TRAVEL_REVIEW_AND_CONFIRM = "ADD_MORE_COVERS_TRAVEL_REVIEW_AND_CONFIRM";

// Travel-specific cover options (based on actual travel insurance covers)
export const travelCoverOptions = [
  {
    id: "CPER137",
    name: "Summer Activities",
    name_ar: "الأنشطة الصيفية",
    description: "Coverage for summer activities during your trip",
    description_ar: "تغطية الأنشطة الصيفية أثناء رحلتك",
    price: 15.0, // Base price - will be updated from API
    coverCode: "CPER137",
    included: false,
    showCover: true,
    defaultIncludedInPlan: false,
    includedWithOther: false,
    disabled: false
  },
  {
    id: "CPER17", 
    name: "Winter Activities",
    name_ar: "الأنشطة الشتوية",
    description: "Coverage for winter activities during your trip",
    description_ar: "تغطية الأنشطة الشتوية أثناء رحلتك",
    price: 25.0, // Base price - will be updated from API
    coverCode: "CPER17",
    included: false,
    showCover: true,
    defaultIncludedInPlan: false,
    includedWithOther: false,
    disabled: false
  }
];

// Function to initialize cover options with current policy data
export const initializeTravelCoverOptions = (currentCovers = []) => {
  return travelCoverOptions.map(option => {
    // Check if this cover is already included in the policy
    const existingCover = currentCovers.find(cover => cover.CoverCode === option.coverCode);
    
    return {
      ...option,
      included: !!existingCover,
      defaultIncludedInPlan: !!existingCover,
      price: existingCover ? existingCover.Price || option.price : option.price
    };
  });
};

// Function to get selected covers for API call
export const getSelectedTravelCovers = (coverOptions) => {
  return coverOptions.filter(cover => cover.included && !cover.defaultIncludedInPlan);
};

// Calculate total additional premium
export const calculateAdditionalPremium = (coverOptions) => {
  return coverOptions
    .filter(cover => cover.included && !cover.defaultIncludedInPlan)
    .reduce((total, cover) => total + (cover.price || 0), 0);
};